import React, { useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';
import {
  getBrokerageForSelectedAccount,
  normalizeAccountBrokerage,
} from '../../../../../utils/accountRouting';

const Account = observer(({ top, dispatchTop }) => {
  const { accountBalanceStore } = useWebsocketStore();
  return (
    <RenderAccountNumbers
      values={accountBalanceStore.balances}
      top={top}
      dispatchTop={dispatchTop}
    />
  );
});

export default Account;
/*
export default class Account1 extends React.Component {
  constructor(props) {
    super(props);
    this.observable = BalancesObservable;
    this.component = RenderAccountNumbers;
    this.state = { storedValues: {} };
  }

  componentDidMount() {
    this.subscription = this.observable.subscribe((value) =>
      this.setState({ storedValues: value })
    );
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  render() {
    const Component = this.component;
    return (
      <Component
        values={this.state.storedValues}
        top={this.props.top}
        dispatchTop={this.props.dispatchTop}
      />
    );
  }
}*/

function RenderAccountNumbers(props) {
  let top = props.top;
  let dispatchTop = props.dispatchTop;
  let accounts = [
    {
      accountId: 'BACKTEST',
      nickname: 'SIM',
      accountType: 'paper',
      brokerage: 'BACKTEST',
    },
  ];
  let balances = props.values;

  if (balances !== undefined) {
    let accts = [...accounts];
    for (let accountId in balances) {
      if (accountId === 'BACKTEST') {
        continue;
      }
      let account = {
        accountId: accountId,
        nickname: balances[accountId].nickname,
        accountType: balances[accountId].account_type,
        brokerage: normalizeAccountBrokerage({
          accountNumber: accountId,
          brokerage: balances[accountId].brokerage,
        }),
      };
      accts.push(account);
    }

    //     let backtest = {
    //         accountId: "BACKTEST",
    //         nickname: "BACKTEST",
    //    }
    //     accts.push(backtest);
    accounts = accts;
  }

  useEffect(() => {
    if (top.accountNumber === 'BACKTEST' && top.brokerage !== 'BACKTEST') {
      dispatchTop({ brokerage: 'BACKTEST' });
      return;
    }

    const selectedBrokerage = getBrokerageForSelectedAccount(
      top.accountNumber,
      accounts.map((account) => ({
        accountNumber: account.accountId,
        brokerage: account.brokerage,
      }))
    );
    if (selectedBrokerage && selectedBrokerage !== top.brokerage) {
      dispatchTop({ brokerage: selectedBrokerage });
    }
  }, [accounts, dispatchTop, top.accountNumber, top.brokerage]);

  return (
    <React.Fragment>
      <div style={{ width: '100%' }}>
        <Typography style={{ fontSize: 10, marginBottom: 4 }}>
          Account #
        </Typography>
        <select
          value={top.accountNumber !== 'none' ? top.accountNumber : 'none'}
          onChange={(ev) => {
            const accountId = ev.target.value;
            const selected = accounts.find(
              (account) => account.accountId === accountId
            );
            if (!selected) {
              dispatchTop({ accountNumber: 'none', brokerage: 'none' });
              return;
            }

            if (accountId === 'BACKTEST') {
              dispatchTop({
                accountNumber: 'BACKTEST',
                brokerage: 'BACKTEST',
              });
              return;
            }

            dispatchTop({
              accountNumber: accountId,
              brokerage: selected.brokerage ?? 'none',
            });
          }}
          size={Math.min(Math.max(accounts.length, 2), 6)}
          style={buildListBoxStyle(Math.min(Math.max(accounts.length, 2), 6))}
        >
          <option value="none">
            Select account
          </option>
          {accounts.map((account) => (
            <option key={account.accountId} value={account.accountId}>
              {buildAccountLabel(account)}
            </option>
          ))}
        </select>
      </div>
    </React.Fragment>
    /*
        <TextInput
          label="Account number:"
          placeholder="Please enter an account number..."

          value={top.accountNumber != null ? top.accountNumber : ""}
          onChange={(val) => dispatchTop({ accountNumber: val })}
        />
        */
  );
}

function buildAccountLabel(account) {
  const parts = [];
  if (account.nickname) parts.push(account.nickname);
  if (account.accountId) parts.push(account.accountId);
  if (account.accountType) parts.push(account.accountType);
  if (
    account.brokerage &&
    account.brokerage !== 'BACKTEST' &&
    account.brokerage !== 'none'
  ) {
    parts.push(account.brokerage);
  }
  return parts.length > 0 ? parts.join(' - ') : 'Account';
}

function buildListBoxStyle(size) {
  return {
    width: '100%',
    fontSize: 10,
    boxSizing: 'border-box',
    minHeight: size <= 1 ? 32 : undefined,
    maxHeight: size <= 1 ? 32 : 132,
    padding: '4px 6px',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: 4,
    backgroundColor: 'white',
  };
}
